<template>
    <el-row style="padding-right: 20px;">
        <el-col :span="(dual && (!item.row))?12:24" v-for="(item,field) in fields" :key="field">
            <el-form-item :label="english?(item.title_en || item.title):item.title + ':'"
                          :prop="field">
                <el-input v-if="['text','textarea','password'].includes(item.type)"
                          v-model="single[field]"
                          :placeholder="english?(item.placeholder_en || item.placeholder):item.placeholder"
                          :disabled="item.readonly"
                          :type="item.type == 'password'? 'text' : item.type"
                          :size="item.size?item.size:'small'">
                </el-input>
                <el-input-number v-if="'number' === item.type"
                                 controls-position="right"
                                 v-model="single[field]"
                                 :placeholder="english?(item.placeholder_en || item.placeholder):item.placeholder"
                                 :disabled="item.readonly"
                                 style="width: 100%"
                                 :size="item.size?item.size:'small'">
                </el-input-number>

                <el-select v-if="'select'==item.type"
                           clearable filterable
                           v-model="single[field]"
                           :placeholder="english?(item.placeholder_en || item.placeholder):item.placeholder"
                           :disabled="item.readonly"
                           :size="item.size?item.size:'small'"
                           :multiple="'true'===item.multiple"
                           :style="{width:'100%'}">
                    <el-option v-for="(option,key) in (english?(item.options_en || item.options):item.options)"
                               :label="option" :value="key+''" :key="key"></el-option>
                </el-select>
                <el-autocomplete v-if="'autocomplete'==item.type"
                                 v-model="single[field]"
                                 :placeholder="english?(item.placeholder_en || item.placeholder):item.placeholder"
                                 :disabled="item.readonly"
                                 :size="item.size?item.size:'small'"
                                 :fetch-suggestions="makeFetchSuggestions(item)"
                                 :style="{width:'100%'}">
                </el-autocomplete>
                <el-switch v-if="'switch'==item.type" v-model="single[field]"
                           :active-value="item.active || '1'"
                           :inactive-value="item.inactive || '0'"
                           :disabled="item.readonly"
                           :size="item.size?item.size:'small'">
                </el-switch>
                <el-date-picker
                        v-if="'date'==item.type" v-model="single[field]"
                        :disabled="item.readonly"
                        :size="item.size?item.size:'small'"
                        type="date"
                        value-format="yyyy-MM-dd"
                        :placeholder='("选择时间")'>
                </el-date-picker>
                <el-time-select
                        v-if="'time'==item.type" v-model="single[field]"
                        :disabled="item.readonly"
                        :size="item.size?item.size:'small'"
                        value-format="hh:mm"
                        :picker-options="{
                                    start: '08:00',
                                    step: '00:05',
                                    end: '23:45'
                                  }"
                        :placeholder='("选择时间")'>
                </el-time-select>
                <picture-upload v-if="'picture' ===item.type"
                                :size="item.size || 'small'"
                                :multiple="!!item.multiple"
                                :list.sync='single[field]'
                                :bgcolor="item.bgcolor"
                                :placeholder="item.placeholder"
                >
                </picture-upload>
                <el-date-picker v-if="'date-range' === item.type"
                                v-model="single[field]"
                                type="daterange"
                                :range-separator="('至')"
                                :start-placeholder="('开始日期')"
                                value-format="yyyy-MM-dd"
                                :end-placeholder="('结束日期')">
                </el-date-picker>
            </el-form-item>
        </el-col>
    </el-row>
</template>

<script>
    import PictureUpload from "./picture-upload";

    export default {
        name: "front-single-form",
        components: {PictureUpload},
        data() {
            return {}
        },
        props: {
            single: {
                type: Object,
                default() {
                    return {}
                }
            },
            fields: {
                type: Object,
                default() {
                    return {}
                }
            },
            dual: {
                type: [Boolean, Number],
                default() {
                    return false
                },
            }
        },
        computed: {
            english() {
                return false;
            },
        },
        methods: {
            makeFetchSuggestions(item) {
                return function autoCompleteFetch(a, cb) {
                    cb(item.options.map((i) => {
                        return {value: i, label: i};
                    }));

                };
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
